import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../config/firebase';

export default function ProtectedRoute({ children }) {
  const [authState, setAuthState] = useState({
    isAuthenticated: false,
    isLoading: true,
  });
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setAuthState({
        isAuthenticated: !!user,
        isLoading: false,
      });
    });

    return () => unsubscribe();
  }, []);

  if (authState.isLoading) {
    return <div className="loading-container">Checking authentication...</div>;
  }

  if (!authState.isAuthenticated) {
    return <Navigate to="/" state={{ from: location.pathname }} />;
  }

  return children;
}